import { useMemo } from 'react';

import { ProtocolEventsItem } from '@/pages/Vaccination/components/task/item/ProtocolEventsItem';
import { EventProtocol } from '@/pages/Vaccination/components/task/types';
import { UUID } from '@/shared/api/types';
import { getNameFromEventProtocols } from '@/utils/task';

import cl from './styles.module.scss';

interface ProtocolEventsStructureProps {
  events: EventProtocol[];
  structuralDivisionId: UUID;
}
export const ProtocolEventsStructure = ({
  events,
  structuralDivisionId,
}: ProtocolEventsStructureProps) => {
  const structuralDivisionName = useMemo(
    () => getNameFromEventProtocols(events),
    [events],
  );

  return (
    <>
      <div className={cl.name}>{structuralDivisionName}</div>
      {events.map((item) => (
        <ProtocolEventsItem {...item} key={item.id} />
      ))}
    </>
  );
};
